import Bounce from './Bounce';
import Breathe from './Breathe';
import Blink from './Blink';
import Cross from './Cross';
import DVD from './DVD';
import Flash from './Flash';
import Flip from './Flip';
import Fold from './Fold';
import Jello from './Jello';
import Poke from './Poke';
import Rubber from './Rubber';
import Pulse from './Pulse';
import Spin from './Spin';
import Swing from './Swing';
import Wiggle from './Wiggle';
export const ongoingAnimations = {
  Bounce,
  Breathe,
  Blink,
  Cross,
  DVD,
  Flash,
  Flip,
  Fold,
  Jello,
  Poke,
  Rubber,
  Pulse,
  Spin,
  Swing,
  Wiggle
};
//# sourceMappingURL=index.js.map